
export const ADD_TO_CART = 'ADD_TO_CART'

export const SET_CART_ITEMS = 'SET_CART_ITEMS'

export const SET_CHECKOUT_STATUS = 'SET_CHECKOUT_STATUS'

export const SET_INFO = 'SET_INFO'

export const SET_RESULT = 'SET_RESULT'

export const SET_TAG = 'SET_TAG'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js